import types from './types';

export const state = {
  active: {
    id: '',
    name: '',
    type: '',
    config: {},
  },
  list: {},
};

const findById = (list, accountId) => {
  const byId = account => account.id === accountId;

  return list.findIndex(byId);
};

export const mutations = {
  [types.SET_LIST](state, list) {
    state.list = list;
  },
  [types.ADD_TO_LIST](state, newAccount) {
    state.list.push(newAccount);
  },
  [types.EDIT_ITEM](state, editedAccount) {
    const index = findById(state.list, editedAccount.id);
    state.list.splice(index, 1, editedAccount);
  },
  [types.REMOVE_ITEM](state, accountId) {
    const index = findById(state.list, accountId);
    state.list.splice(index, 1);
  },
  [types.SET_EMAIL_SERVICE_NAME](state, name) {
    state.active.name = name;
  },
  [types.SET_EMAIL_SERVICE_TYPE](state, accountType) {
    const lastId = state.active.id;
    const lastName = state.active.name;
    state.active = {
      id: lastId,
      name: lastName,
      type: accountType,
      config: {},
    };
  },
  [types.SET_EMAIL_SERVICE_CONFIG](state, { key, value }) {
    if (key === '') {
      state.active.config = value;
    } else {
      state.active.config[key] = value;
    }
  },
  [types.RESET_ACTIVE](state) {
    state.active = {
      id: '',
      name: '',
      type: '',
      config: {},
    };
  },
  [types.SET_ACTIVE](state, account) {
    state.active.id = account.id;
    state.active.name = account.name;
    state.active.type = account.type;
    state.active.config = account.config;
  },
};



// WEBPACK FOOTER //
// ./src/screens/Account/store/mutations.js